import { fetchConfig } from "../config";

const defaultProductionApiUrl =
  "https://corporateapiservice.nicebeach-895ccbf8.francecentral.azurecontainerapps.io/api";
const runtimeProductionApiUrl =
  typeof window !== "undefined" && window.RUNTIME_CONFIG
    ? window.RUNTIME_CONFIG.API_URL
    : undefined;

// Production URL
const production = {
    // url: "https://corporateapiservicebeta.nicebeach-895ccbf8.francecentral.azurecontainerapps.io/api",
  url: runtimeProductionApiUrl || defaultProductionApiUrl,
  // url: "http://10.20.80.62:1234/api",
  // url: 'https://localhost:44342/api',
  // url: "https://localhost:7031/api",
  //  url: 'http://10.20.80.67/corporateAPi/api',
  ivs: "https://ivsbackapi.suyool.com/",
  //  url: "http://10.20.80.62/corporateAPi/api",
  //   ivs: "http://10.20.80.62/IVS",
  // url: 'https://localhost:7031/api',
  // ivs: "https://ivsbackapi.suyool.com/",
  // url: "http://10.20.80.62/corporateAPi/api",
  // webBaseUrl: "https://suyool.com",
  webBaseUrl: "https://utilities.suyool.com/",
  // webBaseUrl: 'http://10.20.80.79'
};

// Development URL
const development = {
  // url: "https://corporateapiservicebeta.nicebeach-895ccbf8.francecentral.azurecontainerapps.io/api",
   url: "https://corporateapiservice.nicebeach-895ccbf8.francecentral.azurecontainerapps.io/api",
  // url: "http://10.20.80.62:1234/api",
  //url: "https://localhost:7031/api",
  // url: 'https://localhost:44342/api',
  // url: "http://10.20.80.67/corporateAPi/api",
  // url: "http://10.20.80.62/corporateAPi/api",
  // url: "http://10.20.80.87/Corporate/api",
  // ivs: "http://10.20.80.62/IVS",
  ivs: "https://ivsbackapi.suyool.com/",
  // url: 'http://10.20.80.87/CorporateBackAPI/api',
  // url:'http://10.20.80.56/CorporateAPI/api',
  // url : 'http://10.20.80.62/CorporateAPIRoles/api',
  // webBaseUrl: 'http://10.20.80.62/corporateAPi',
  // webBaseUrl: 'http://10.20.80.83',
  // webBaseUrl: 'http://10.20.80.79',
  // webBaseUrl: "http://127.0.0.1:8000",
  // webBaseUrl: "http://10.20.80.74",
  webBaseUrl: "https://utilities.suyool.com/",
};

export const isDevMode = process.env.NODE_ENV !== "production";

// const configData = await fetchConfig();


export const checkQrStatusTimer = 3000;
export const qrTimeoutMinutes = isDevMode ? 10 : 1;
export const DefaultLocation = { lat: 35.1264, lng: 33.4299 };
export const config = isDevMode ? development : production;
export const certificate = process.env.REACT_APP_CERTIFICATE;

export const entityRoles = {
  superAdmin: "SUPERADMIN",
  admin: "ADMIN",
  supervisor: "Supervisor",
  viewer: "VIEWER",
  payrollManager: "PAYROLL MANAGER",
};

export const entityTypes = {
  legal: "LEGALENTITY",
  merchant: "MERCHANTEMPLOYEE",
};

export const inactivityDuration = 5 * 60 * 1000; // 5 minutes

export const validationTypes = {
  cardInfo: 1,
  employee: 2,
  s2s: 3,
  cashing: 4,
};

export const validationFlags = {
  successOk: 0,
  successContinue: 1,
  exchangeBills: 84,
  topupBills: 90,
  PaymentComfirmationPrepaid: 101,
  payrollError: 437,
};
